import React from "react";
import { Mail, Phone, MapPin, Building2, Clock } from "lucide-react";

export default function ContactPage() {
  return (
    <div className="max-w-5xl mx-auto px-5 md:px-8 py-14">
      <div className="mb-10">
        <div className="kyro-overline">Contact us</div>
        <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter mt-3">Say hello, we reply fast.</h1>
        <p className="text-kyro-mute mt-3 max-w-2xl">Reach us through the details below — our team responds during business hours.</p>
        <p className="text-xs text-kyro-faint mt-2">Last updated on 20-07-2026 18:51:41</p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div className="kyro-card p-8">
          <Building2 className="w-5 h-5 text-[#FF4433] mb-4" />
          <div className="kyro-overline mb-2">Legal entity</div>
          <p className="font-display font-bold text-xl">BABA MEDIA</p>
        </div>

        <div className="kyro-card p-8">
          <Phone className="w-5 h-5 text-[#FF4433] mb-4" />
          <div className="kyro-overline mb-2">Telephone</div>
          <a href="tel:+919924731282" data-testid="contact-phone" className="font-display font-bold text-xl hover:text-[#FF4433] transition-colors">+91 99247 31282</a>
        </div>

        <div className="kyro-card p-8">
          <Mail className="w-5 h-5 text-[#FF4433] mb-4" />
          <div className="kyro-overline mb-2">Email</div>
          <a href="mailto:ankitsharmap05@gmail.com" data-testid="contact-email" className="font-display font-bold text-base md:text-lg hover:text-[#FF4433] transition-colors break-all">ankitsharmap05@gmail.com</a>
        </div>

        <div className="kyro-card p-8">
          <Clock className="w-5 h-5 text-[#FF4433] mb-4" />
          <div className="kyro-overline mb-2">Response time</div>
          <p className="font-display font-bold text-xl">Within 2–6 hours</p>
          <p className="text-xs text-kyro-mute mt-1">Monday to Saturday, 10 AM – 8 PM IST</p>
        </div>

        <div className="kyro-card p-8 md:col-span-2">
          <MapPin className="w-5 h-5 text-[#FF4433] mb-4" />
          <div className="kyro-overline mb-2">Registered address</div>
          <p className="text-lg leading-relaxed">Shop No. 19, New Life CHS,<br/>Mumbai, Maharashtra — PIN 400064</p>

          <div className="kyro-divider my-6" />

          <div className="kyro-overline mb-2">Operational address</div>
          <p className="text-lg leading-relaxed">No. 19, New Life CHS, near Valani Metro Station,<br/>Mumbai Suburban, Maharashtra — PIN 400064</p>
        </div>
      </div>

      <div className="mt-10 text-sm text-kyro-mute leading-relaxed">
        <p>For anything time-sensitive (order status, credential issues, refunds), email us with your order ID for the fastest resolution.</p>
      </div>
    </div>
  );
}
